import styled from 'styled-components';
import { rem } from 'polished';
import { ModalNeedHelpStyled } from '../ModalNeedHelpStyled';

export const ModalNeedHelpStyledAC = styled(ModalNeedHelpStyled)``;
